import { createContext } from 'react';

/**
 * Used when an app is embedded inside the Core Shell.
 * The Shell injects token + user through this context so
 * embedded apps never trigger their own Auth0 flow.
 */
const ShellAuthContext = createContext(null);

export default ShellAuthContext;
